import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import './MissionVision.css';
import { useTranslation } from 'react-i18next';

const MissionVision = () => {
  const { t } = useTranslation();

  return (
    <PageTemplate title={t('mission_vision.title')}>
      <div className="mv-root">
        {/* Animasyonlu Hero Bölümü */}
        <div className="mv-hero">
          <div className="mv-hero-bg">
            <div className="mv-particles">
              {[...Array(18)].map((_, i) => (
                <div key={i} className={`mv-particle mv-particle-${i+1}`}></div>
              ))}
            </div>
            <video className="mv-hero-video" autoPlay muted loop playsInline>
              <source src="/fenfakultesivideo.mp4" type="video/mp4" />
            </video>
            <div className="mv-hero-overlay" />
          </div>
          <div className="mv-hero-content">
            <h1 className="mv-hero-title">{t('mission_vision.hero.title')}</h1>
            <p className="mv-hero-desc">{t('mission_vision.hero.subtitle')}</p>
          </div>
        </div>

        {/* Glassmorphism Misyon & Vizyon Kartları */}
        <div className="mv-cards">
          <div className="mv-card mv-mission">
            <div className="mv-card-icon mv-animate-icon">
              <svg xmlns="http://www.w3.org/2000/svg" className="mv-svg-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
            </div>
            <h2 className="mv-card-title">{t('mission_vision.mission.title')}</h2>
            <p className="mv-card-text">{t('mission_vision.mission.description')}</p>
          </div>
          <div className="mv-card mv-vision">
            <div className="mv-card-icon mv-animate-icon">
              <svg xmlns="http://www.w3.org/2000/svg" className="mv-svg-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" /></svg>
            </div>
            <h2 className="mv-card-title">{t('mission_vision.vision.title')}</h2>
            <p className="mv-card-text">{t('mission_vision.vision.description')}</p>
          </div>
        </div>

        {/* Değerlerimiz Kartları */}
        <div className="grid gap-6 md:grid-cols-3 mb-12">
          {/* Bilimsel Mükemmeliyet */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-hacettepe-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
            <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('mission_vision.values.scientific_excellence.title')}</h4>
            <p className="text-gray-600">{t('mission_vision.values.scientific_excellence.description')}</p>
          </div>

          {/* Yenilikçilik */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-hacettepe-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('mission_vision.values.innovation.title')}</h4>
            <p className="text-gray-600">{t('mission_vision.values.innovation.description')}</p>
          </div>

          {/* Toplumsal Fayda */}
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-hacettepe-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
              </svg>
            </div>
            <h4 className="text-xl font-semibold text-gray-800 mb-2">{t('mission_vision.values.social_benefit.title')}</h4>
            <p className="text-gray-600">{t('mission_vision.values.social_benefit.description')}</p>
          </div>
        </div>

        {/* Alt Banner */}
        <div className="bg-gradient-to-br from-gray-900 to-hacettepe-blue rounded-xl shadow-lg overflow-hidden">
          <div className="px-8 py-12 sm:px-12">
            <div className="relative max-w-3xl mx-auto text-center">
              <h3 className="text-3xl font-bold text-white mb-6">
                {t('mission_vision.bottom_banner.title')}
              </h3>
              <p className="text-lg text-gray-300">
                {t('mission_vision.bottom_banner.subtitle')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default MissionVision; 